import { Component, Renderer2, ElementRef, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Url } from 'url';
import { TranslateService } from '@ngx-translate/core';
import { AppSettingsService } from '../../shared/app-settings/app-settings.service';

interface Link {
  link: SafeUrl | Url;
  external: boolean;
  title: string;
  ico: string;
  name: string;
}

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HelpComponent implements AfterViewInit {

  public links: Link[] = [{
		link: this.appSettings.data.user.registration_language !== 'pl' ?
			'https://lpgenerator.zendesk.com/hc/ru' : 'https://lpgenerator.freshdesk.com/support/solutions',
		external: true,
		title: this.translation.instant('База знаний'),
    ico: 'history_black_mini',
    name: 'history'
	}, {
		link: this.appSettings.data.user.registration_language !== 'pl' ?
			'https://lpgenerator.zendesk.com/hc/ru/requests/new' : 'https://lpgenerator.freshdesk.com/support/tickets/new',
		external: true,
		title: this.translation.instant('Отправить запрос в support'),
    ico: 'email_black_mini',
    name: 'email'
	}, {
		link: 'http://support.lpgenerator.ru/',
		external: false,
		title: this.translation.instant('Умная помощь (чат)'),
    ico: 'chat_black_mini',
    name: 'chat'
	}, {
		link: '#',
		external: false,
		title: this.translation.instant('Умная помощь'),
    ico: 'chat_black_mini',
    name: 'freshdesk'
	}, {
		link: this.sanitizer.bypassSecurityTrustUrl('skype:lpgenerator?chat'),
		external: false,
		title: this.translation.instant('Skype'),
    ico: 'skype_black_mini',
    name: 'skype'
  }, {
    link: this.appSettings.data.user.registration_language === 'pl' ? '/pl/kontakt/' : '/contact-us/',
    external: false,
    title: this.translation.instant('Другие контакты'),
    ico: 'phone_black_mini',
    name: 'phone'
  }];

  constructor(
    private _renderer2: Renderer2,
    private elRef: ElementRef,
    private sanitizer: DomSanitizer,
    private translation: TranslateService,
    private appSettings: AppSettingsService
  ) {
    this.links = this.linksFilter(this.links);
  }

  /**
   * Скрываем ссылки для Польши
   * @param {Link[]} links
   * @returns {Link[]}
   */
	private linksFilter(links: Link[]): Link[] {
		return links.filter((link: Link) => {
			const isPolish = this.appSettings.data.user.registration_language === 'pl';
			const isRu = this.appSettings.data.user.registration_language === 'ru';
			if (isRu && ( link.name === 'freshdesk' ) ) {
				return false;
			}
			if (isPolish && (link.name === 'skype' || link.name === 'phone' || link.name === 'chat') ) {
				return false;
			} else {
				return true;
			}
		});
	}

	openFreshdeskWidget() {
		(<any>window).FreshWidget.show();
		return false;
	}

	openZopim() {
		(<any>window).zE.activate();
		return false;
	}

	ngAfterViewInit() {
		// assume dynamic HTML was added before
		if ( this.appSettings.data.user.registration_language === 'pl' ) {
			this._renderer2.listen( this.elRef.nativeElement.querySelector( '.item__link.freshdesk' ), 'click', this.openFreshdeskWidget );
		}
		if ( this.appSettings.data.user.registration_language === 'ru' ) {
			this._renderer2.listen( this.elRef.nativeElement.querySelector( '.item__link.chat' ), 'click', this.openZopim );
		}
	}
}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/help/help.component.ts